import { enmPolicyholderResponseTypes, IDamageCase } from "../../baseInfo/damageCase/interfaces";
import { BaseComponent, IBaseProps, IBaseStates } from "../../components/infrastructure/baseComponent";
import { Core } from "../../components/infrastructure/core";
import { enmEntityState, ICallOptions, IResult } from "../../components/infrastructure/models";
import { PolicyholderConfirmationForm } from "../../evaluation/damageCaseEvaluator/components";
import { IPolicyholderConfirmation } from "../../evaluation/damageCaseEvaluator/policyholderConfirmation";

interface IPolicyholderConfirmationProps extends IBaseProps {
    damageCase: IDamageCase;
}

interface IPolicyholderConfirmationStates extends IBaseStates {
    currentEntity: IPolicyholderConfirmation;
}

export class PolicyholderConfirmation extends BaseComponent<IPolicyholderConfirmationProps, IPolicyholderConfirmationStates> {
    constructor(props: IPolicyholderConfirmationProps) {
        super(props)
        this.state = {
            isAuthorized: true,
            loading: false,
            windowSize: window.innerWidth <= 765 ? 1 : 2,
            currentEntity: {
                RowGuid: Core.newId(),
                State: enmEntityState.Added
            } as any
        };
    }
    submit = async (values: any) => {
        const responseType = values["ResponseType"];
        const bank = values["Bank"];
        const bankBranch = values["BankBranch"];
        const bankAccountNo = values["BankAccountNo"];
        const bankCardNo = values["BankCardNo"];

        let fetchOpt: ICallOptions = {
            url: "portal/confirmation",
            data: {
                data: {
                    TicketNo: this.props.damageCase.TicketNo,
                    ResponseType: responseType,
                    ObjectionDescription: responseType === enmPolicyholderResponseTypes.Objection ? values["ObjectionDescription"] : null,
                    ShebaNo: responseType === enmPolicyholderResponseTypes.Pay ? values["ShebaNo"].replace(/[^0-9.]/g, '') : null,
                    BankCode: bank?.Code,
                    BankBranch: bankBranch,
                    BankAccountNo: bankAccountNo,
                    BankCardNo: bankCardNo
                }
            },
            onSuccess: (result: IResult) => {
                if (result.ValidationState.Successful) {
                    Core.successNotification('پاسخ ارسال شد');
                    this.props.onClose && this.props.onClose({ preventBack: true });
                }
            }
        };
        return await this.callApi(fetchOpt);
    }
    virtualRender() {
        return (
            <PolicyholderConfirmationForm
                key={this.state.currentEntity.RowGuid}
                parent={this}
                currentEntity={this.state.currentEntity}
                damageCase={this.props.damageCase}
                loading={this.state.loading}
                onSubmit={this.submit}
                onClose={this.props.onClose}
                damageCaseDocumentTypeAttachments={[]}
            />
        );
    }
}